import React from 'react'

export default function LoadingScreen() {
	return <div>Daten werden geladen...</div>
}
